import produce from "immer";
import validateStep from "./validateStep";

import { State } from "../types";

export type ZipPasswordType = "SAME" | "INDIVIDUAL";

export type ChangeZipPasswordType = {
  type: "changeZipPasswordType";
  payload: ZipPasswordType;
};

export function changeZipPasswordType(state: State, newType: ZipPasswordType) {
  return produce(state, draft => {
    draft.steps.target.done = false;
    // https://mxhero.atlassian.net/browse/MXH-5211

    // Send an INDIVIDUAL Zip file with his own PASSWORD to each recipient
    //   + Si tiene storage → syncAllByRule = false
    if (newType === "INDIVIDUAL") {
      draft.rule.zipAttachments.passwordPerRecipient = true;

      if (draft.rule.zipAttachments.storage) {
        draft.rule.zipAttachments.storage.syncAllByRule = false;
      }
    }

    // Send the SAME Zip file with his own PASSWORD to all recipientsç
    //  + Si tiene storage → syncAllByRule = true
    if (newType === "SAME") {
      draft.rule.zipAttachments.passwordPerRecipient = false;

      if (draft.rule.zipAttachments.storage) {
        draft.rule.zipAttachments.storage.syncAllByRule = true;
      }
    }

    validateStep("target", draft);
  });
}
